export class Convert {
  static signalingMessageICECandidate2RTCIceCandidateInit (message) {
    const rtcIceCandidate = {
      candidate: message.sdp,
      sdpMLineIndex: message.mlineindex,
      sdpMid: message.mid,
    }

    return rtcIceCandidate
  }

  /**
   * converts the protobuf monitor to a monitor struct which will be stored in state
   * this way state's monitor format is independent of protobuff changes
   * @param {*} monitor a monitor from the protobuf message
   */
  static protobuffMonitor2Monitor (monitor) {
    return {
      id: monitor.id,
      isPrimary: monitor.isPrimary,
      width: monitor.width,
      height: monitor.height,
    }
  }
}
